var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"id":_vm.fieldId,"checked":_vm.value,"value":true,"unchecked-value":false,"disabled":_vm.disabled},on:{"change":_vm.changeHandler,"input":_vm.inputHandler}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }